module.exports = {"140212100":"新荣镇","140212200":"破鲁堡乡","140212202":"郭家窑乡","140212203":"花元屯乡","140212206":"西村乡","140212207":"上深涧乡","140212209":"堡子湾乡","140212400":"新荣区街道管理中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140212.json
// module id = 243
// module chunks = 0